import classNames from 'classnames'
import React from 'react'
import cl from '../classnames.scss'
import s from './subtitle.scss'
import {SubtitleProps} from './index'

export const Subtitle = ({dataHook, className, text, mobile, customColor, compact}: SubtitleProps) => (
  <h2
    className={classNames(
      cl.evSubtitlesFont,
      customColor || cl.evSubtitlesColor,
      mobile ? s.mobile : s.desktop,
      compact ? s.compact : '',
      s.upgrade,
      className,
    )}
    data-hook={dataHook}
  >
    {text}
  </h2>
)
